<template>
	<div class="intro">
		<MainColumn class="center">
			<div class="wrap">
				<div class="devoto-oli">
					<svg version="1.1" id="Livello_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
						viewBox="0 0 779 497.9" style="enable-background:new 0 0 779 497.9;" xml:space="preserve">
						<g>
							<path fill="#fff" class="st0" d="M779,251.8c-2.9,82-35.1,152.1-104.3,203.2c-30.6,22.6-65.1,36.8-102.9,40.5c-99.4,9.6-175.2-30.6-226.6-114.5
								c-62.8-102.4-43.4-237.5,43.2-318.3C425,28.5,468.1,7.2,518.1,2.1c74.6-7.7,138.3,16.5,190.2,70.2c41.2,42.6,63.3,94.4,69.2,153.2
								C778.4,233.2,778.4,241.1,779,251.8z M350,237.9c0,35.2,3.8,59,11.9,82c20.4,57.6,57.6,100.3,114.7,123.3
								c70.9,28.6,152.2,8.8,203.8-48c57.1-62.9,73.5-152.5,39.4-230.5C687.7,91,632,47.2,549.8,42.4c-41.7-2.4-79.9,9.8-113.4,34.5
								C378.7,119.4,352.1,178.1,350,237.9z"/>
							<path fill="#fff" class="st0" d="M0,497.9c0-14.4,0-27.7,0-41.6c5.5-0.3,11-0.3,16.4-1c80-10,134.3-54.5,162.1-128.4
								c31.1-82.9,16.2-159.5-43.5-225.6C104,67,64.3,48,18.2,42.8c-5.9-0.7-11.9-0.7-18.1-1c0-13.8,0-27.2,0-41.8
								c11.7,1.1,23.2,1.2,34.4,3.3c17,3.2,68.3,12.3,116.3,53.9c46,39.8,62.9,86.3,70,106.6c4.4,12.6,12.9,40.2,14.4,76.5
								c1.4,32.4-3.4,56.8-4.6,62.3c-14.4,69.8-57,113.4-70.4,127.3c-36.2,37.9-81.7,59.6-134.1,65.9C17.7,496.9,9.1,497.2,0,497.9z"/>
						</g>
					</svg>

				</div>
				<Logo class="logo" />
				<Loading v-if="loading" />
				<div class="difficulty">
					<span class="size-xs">Modalità</span>
					<Switcher v-on:update-value="changeDifficulty" val1="Facile" val2="Difficile" />
				</div>
				<div class="buttons">
					<Button value="Singolo" @click.native="goto('game', 1)" />
					<Button value="A squadre" :double="true" @click.native="goto('game', 2)" />
					<Button color="white" :secondary="true" value="Regole" :double="true" @click.native="rulesDialog = true" />
					<div @click="creditsDialog = true" class="credits">Crediti</div>
				</div>
				<v-dialog v-model="creditsDialog" transition="dialog-bottom-transition" max-width="720px">
					<div class="card">
						<h2>Crediti</h2>
						<div class="content">
							<div class="label">Progettazione</div>
							<div class="value">Fabio Ferri, Simona Ravalico</div> 
							<div class="value">con la Consulenza scientifica del Istituto di Linguistica Computazionale "Antonio Zampolli" del Consiglio Nazionale delle Ricerche (CNR)</div>
							<div class="label">Sviluppo e Design</div>
							<div class="value">QZR studio, Lucca</div>
							<div class="value" @click="audioCreditsToggle = !audioCreditsToggle">Crediti audio {{audioCreditsToggle? '-' : '+'}}</div>
							<div class="audio-credits" :class="{active: audioCreditsToggle}">
								<div class="value">Freesound.org - Bell, Counter, A (InspectorJ)</div>
								<div class="value">Freesound.org - Whoopsie high pitch (Deleted user)</div>
								<div class="value">Freesound.org - Pop sound (deraj)</div>
								<div class="value">Freesound.org - Felplacerad (simon-ru)</div>
								<div class="value">Freesound.org - Hover (plasterbrain)</div>
								<div class="value">Freesound.org - Horn stabs entrance (bevibeldesign)</div>
								<div class="value">Freesound.org - Left crash (veiler)</div>
								<div class="value">Freesound.org - Orchestra hit (bigdumbweird)</div>

								<div class="value">YouTube Audio Library - Hookah Bar, Silent Partner</div>
								<div class="value">YouTube Audio Library - Mariachiando - Doug Maxwell Jimmy Fontanez</div>
								<div class="value">YouTube Audio Library - Danzon De Pasion (Sting) - Jimmy Fontanez Media Right Productions</div>
								<div class="value">YouTube Audio Library - Argonne - Zachariah Hickman</div>
								<div class="value">YouTube Audio Library - Dorris Day - DJ Williams</div>
								<div class="value">YouTube Audio Library - Drill Gear</div>
								<div class="value">YouTube Audio Library - Ship Bell</div>
								<div class="value">YouTube Audio Library - Female Crowd Celebration</div>
								<div class="value">YouTube Audio Library - Cartoon Long Throw</div>
							</div>
						</div>
					</div>
				</v-dialog>

				<v-dialog v-model="rulesDialog" transition="dialog-bottom-transition" max-width="720px">
					<div class="card">
						<h2>Regole</h2>
						<div class="content">
							<div class="label">Regole del gioco</div>
							<div>
								Una partita è composta da 10 parole che devono essere indovinate a partire dalla loro definizione. Per ogni parola hai a disposizione 60 secondi e una serie di aiuti che incideranno sul punteggio finale.

							</div>
							<div class="label">Multigiocatore</div>
							<div>Con la modalità "a squadre" puoi organizzare un simpatico torneo!</div>
						</div>
					</div>
				</v-dialog>
			</div>
		</MainColumn>
	</div>
</template>

<script>
import MainColumn from "@/components/MainColumn.vue";
import Button from "@/components/Button.vue";
import Switcher from "@/components/Switcher.vue";
import Logo from "@/components/Logo.vue";
import Loading from "@/components/Loading.vue";

export default {
	components: {
		MainColumn,
		Button,
		Switcher,
		Logo,
		Loading,
	},
	data() {
		return {
			creditsDialog: false,
			rulesDialog: false,
			animation: false,
			loading: false,
			audioCreditsToggle: false,
			bannedWords: [
				'Islam',
				'Spermatofite',
				'aborto',
				'accattonaggio',
				'accattone',
				'adulterio',
				'adultero',
				'afghano',
				'aids',
				'anale',
				'ano',
				'anticoncezionale',
				'arabico',
				'arabo',
				'asessuale',
				'asessuato',
				'bantù',
				'barbone',
				'bestemmia',
				'bestemmiare',
				'bocchino',
				'camorra',
				'camorrista',
				'castrato',
				'castrazione',
				'circoncisione',
				'ciucciare',
				'clistere',
				'clitoride',
				'cocaina',
				'cocainomane',
				'coito',
				'colon',
				'contraccettivo',
				'contraccezione',
				'copula',
				'crocifiggere',
				'crocifissione',
				'crocifisso',
				'deflorare',
				'depravato',
				'depravazione',
				'deretano',
				'diarrea',
				'down',
				'ebraico',
				'ebraismo',
				'ebreo',
				'effeminato',
				'eiaculazione',
				'erezione',
				'escremento',
				'eterosessuale',
				'extracomunitario',
				'extraconiugale',
				'fascismo',
				'fascista',
				'fecale',
				'feci',
				'foiba',
				'gay',
				'genitale',
				'glande',
				'gonade',
				'hashish',
				'imene',
				'islamico',
				'islamismo',
				'jihad',
				'lager',
				'leghismo',
				'leghista',
				'lesbica',
				'lesbico',
				'lubrificante',
				'lubrificare',
				'lubrificazione',
				'madonna',
				'mammario',
				'mammella',
				'maomettano',
				'marijuana',
				'massoneria',
				'massonico',
				'masturbare',
				'masturbazione',
				'mulatto',
				'mussulmano',
				'musulmano',
				'nazismo',
				'nazista',
				'omosessuale',
				'omosessualità',
				'orgasmo',
				'orgia',
				'ovaia',
				'ovulazione',
				'ovulo',
				'pedofilia',
				'pedofilo',
				'pene',
				'peto',
				'porno',
				'pornografia',
				'pornografico',
				'prepuzio',
				'preservativo',
				'profilattico',
				'prostata',
				'prostituire',
				'prostituta',
				'prostituzione',
				'pube',
				'purga',
				'purgante',
				'purgare',
				'scopare',
				'sedere',
				'seno',
				'sesso',
				'sessuale',
				'sessualità',
				'sessuato',
				'sgualdrina',
				'shoah',
				'sieropositivo',
				'sodomia',
				'sperma',
				'stuprare',
				'stupratore',
				'stupro',
				'testicolo',
				'transessuale',
				'turgido',
				'urea',
				'uretra',
				'urina',
				'urinare',
				'urinario',
				'vamp',
				'vescica',
				'violentare',
				'vulva',
			]
		};
	},
	mounted() {
		let dictionary = this.$store.state.dictionaryRaw.filter((el) => {
			return this.checkWord(el);
		});

		this.updateProperty({
			property: "dictionary",
			value: dictionary,
		});

		this.updateProperty({
			property: "backgroundColor",
			value: "blue",
		});

		for (let sound in this.$store.state.sounds) {
			this.$store.state.sounds[sound].pause();
			this.$store.state.sounds[sound].currentTime = 0;
			this.$store.state.sounds[sound].playbackRate = 1;
		}
		this.playAudio("intro", true);
	},
	methods: {
		openRules() {},
		checkWord(element, difficult = 0) {
			if (!element.word || !typeof element.word === "string" || element.word.length < 4) return false;
			if (this.bannedWords.includes(element.word)) return false;

			if(!element.MARCA_SEMANTICA.toLowerCase() || !element.MARCA_SEMANTICA.toLowerCase().includes('scienza')) return false;

			switch (true) {
				case window.innerWidth > 1280:
					if (element.word.length > 8) return false;
					break;

				case window.innerWidth > 1024:
					if (element.word.length > 7) return false;
					break;

				case window.innerWidth > 768:
					if (element.word.length > 6) return false;
					break;

				case window.innerWidth > 0:
					if (element.word.length > 6) return false;
					if (element.meaning.length > 137) return false;
					break;
			}

			switch (true) {
				case difficult === "undefined":
				case difficult == 0:
					if (parseInt(element.value) > 10) return false;
					break;

				case difficult == 1:
					if (parseInt(element.value) > 26) return false;
					break;
			}

			return true;
		},
		goto(page, players) {
			this.$store.state.gamemode = players;
			this.$router.push("/" + page);
		},
		changeDifficulty(val) {
			this.updateProperty({
				property: "difficult",
				value: val,
			});

			this.loading = true;
			let dictionary = this.$store.state.dictionaryRaw.filter((el) => {
				return this.checkWord(el, val);
			});
			setTimeout(() => {
				this.loading = false;
			}, 500);

			this.updateProperty({
				property: "dictionary",
				value: dictionary,
			});
		},
	},
};
</script>
<style scoped lang="scss">
.card {
	padding: 1rem;
	border-radius: 1.5rem;
	background: white;
	overflow: auto;
	color: $mondadori-blue;
	.content {
		max-height: calc(100vh - 20rem);
		overflow-y: scroll;
	}
}

.devoto-oli {
	position: absolute;
	height: 1.4rem;
	aspect-ratio: 2/1;
	top: -2rem;
}

.audio-credits {
	font-size: 0.7rem;
	color: #8d8d8d;
	max-height: 0;
	transition: all 0.3s;
	cursor: pointer;
	overflow: hidden;
	&.active {
		max-height: 50rem;
	}
	.label {
		background: transparent;
		margin-bottom: 0rem;
		text-align: left;
		color: #8d8d8d;
	}
}

.label {

	text-transform: uppercase;
	font-weight: bold;
	margin-top: 2.2rem;
	margin-bottom: 1rem;
	background: $mondadori-blue;
	color: white;
	border-radius: 1rem;
	text-align: center;
}

.value {
	border-bottom: 0.1rem dotted;
    padding: 0.3rem 0;
}

.credits {
	position: fixed;
	bottom: 1rem;
	left: 50%;
	transform: translateX(-50%);
	display: inline-block;
	color: white;
	font-size: $xs;
	text-transform: uppercase;
	cursor: pointer;
	text-align: center;
}

.center {
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: calc(100vh - #{px(30)});
	.wrap {
		width: px(400);
		position: relative;
		margin-top: px(-50);
		@include breakpoint(s) {
			width: 90%;
		}
		.logo {
			margin-bottom: px(50);
		}
		.difficulty {
			align-items: center;
			color: #fff;
			text-transform: uppercase;
			display: flex;
			margin-bottom: px(20);
			& > * {
				flex-basis: 50%;
			}
		}
		.buttons {
			display: block;
			width: 100%;
			margin: auto;
			& > * {
				width: 100%;
				margin-bottom: px(20);
			}
		}
	}
	
}
</style>
